import { Client } from "@/Common/Api/Client";
import { GenericResponse } from "@/Common/Api/Dto/GenericResponse";
import { Guid } from "@/Common/Models/Guid";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ExportMode } from "../Models/enum/ExportMode";
import { ICustomFaxSenderResponse } from "./Dto/ICustomFaxSenderResponse";
import { ILoadEmployeeFormSignResponse } from "./Dto/ILoadEmployeeFormSignResponse";
import { ISaveEmployeeFormSignRequest } from "./Dto/ISaveEmployeeFormSignRequest";

class CustomFaxClient {
    /**
     * Fetch the fax sender data for a document ID.
     * @param documentId The ID of the document whose data to fetch.
     */
    public static async fetchFaxSenderData(documentId: Guid): Promise<ICustomFaxSenderResponse> {
        const response = await Client.postAsync<ICustomFaxSenderResponse>(ServerOperations.Server.Myle_GetFaxSenderSourceByDocumentId, { DocumentId: documentId });

        return response.data;
    }

    /**
     * Save an employee form sign request.
     * @param request The employee form sign request to save.
     * @returns Whether the signature was signed successfully.
     */
    public static async saveEmployeeFormSign(request: ISaveEmployeeFormSignRequest): Promise<boolean> {
        const response = await Client.postAsync<GenericResponse>(
            ServerOperations.Server.Myle_Forms_SaveEmployeeFormSign,
            request
        );

        return !response.errors?.any();
    }

    /**
     * Fetch employee form sign data.
     * @param employeeContactId The employee's unique contact or employee ID.
     * @param formId The unique ID of the form to load.
     * @param actionType The export mode for which to get data.
     * @returns Whether the employee has a signature and should sign the form.
     */
    public static async loadEmployeeFormSign(employeeContactId: string, formId: string, actionType: ExportMode): Promise<ILoadEmployeeFormSignResponse> {
        const response = await Client.postAsync<ILoadEmployeeFormSignResponse>(
            ServerOperations.Server.Myle_Forms_LoadEmployeeFormSign,
            {
                EmployeeId: employeeContactId,
                FormId: formId,
                ActionType: actionType
            }
        );

        if (response.errors?.any()) {
            console.error(response.errors);
            return null;
        }

        return response.data;
    }
}

export { CustomFaxClient };
